import { useRef, useState } from 'react';
import { errorText } from './api';

/** Ein Bild wählen, hochladen, ansehen, entfernen – für Logo und Wartezimmer-Bild. */
export function ImageUpload({ current, alt, onUpload, onRemove, hint, previewClass }: { current: string | null; alt: string; onUpload: (file: File) => Promise<void>; onRemove: () => Promise<void>; hint: string; previewClass?: string }) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function run(action: () => Promise<void>) {
    setBusy(true);
    setError(null);
    try {
      await action();
    } catch (e) {
      setError(errorText(e, 'Das hat nicht geklappt. Bitte versuch es mit einer anderen Datei.'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="image-upload">
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        style={{ display: 'none' }}
        onChange={(e) => {
          const file = e.target.files?.[0];
          e.target.value = '';
          if (file) void run(() => onUpload(file));
        }}
      />
      {current && <img className={`image-upload__preview${previewClass ? ` ${previewClass}` : ''}`} src={current} alt={alt} />}
      <div className="row-actions">
        <button type="button" className="button button--secondary button--small" disabled={busy} onClick={() => inputRef.current?.click()}>
          {busy ? 'Lädt hoch …' : current ? 'Anderes Bild wählen' : 'Bild hochladen'}
        </button>
        {current && (
          <button type="button" className="link-button" disabled={busy} onClick={() => void run(onRemove)}>
            Entfernen
          </button>
        )}
      </div>
      <span className="faint small">{hint}</span>
      {error && <div className="error" style={{ marginTop: 8 }}>{error}</div>}
    </div>
  );
}
